
const transformWeeklyData = (zcqlResponse) => {
    const weekly = [
        { name: 'Mon', tasks: 0 },
        { name: 'Tue', tasks: 0 },
        { name: 'Wed', tasks: 0 },
        { name: 'Thu', tasks: 0 },
        { name: 'Fri', tasks: 0 },
        { name: 'Sat', tasks: 0 },
        { name: 'Sun', tasks: 0 }
    ];

    const dayMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    zcqlResponse.forEach(item => {
        const row = item.bookings;
        const date = new Date(row.created_date);
        const dayName = dayMap[date.getDay()];
        const count = Number(row["COUNT(ROWID)"]);

        const index = weekly.findIndex(d => d.name === dayName);
        if (index !== -1) {
            weekly[index].tasks = count;
        }
    });

    return weekly;
};
const transformMonthlyData = (zcqlResponse, year, month) => {
    // month: 1–12
    const daysInMonth = new Date(year, month, 0).getDate();

    // Pre-fill days
    const monthly = Array.from({ length: daysInMonth }, (_, i) => ({
        name: String(i + 1),
        tasks: 0
    }));

    zcqlResponse.forEach(item => {
        const row = item.bookings;
        const date = new Date(row.created_date);
        const day = date.getDate(); // 1–31
        const count = Number(row["COUNT(ROWID)"]);

        monthly[day - 1].tasks = count;
    });

    return monthly;
};
const transformCustomRangeData = (data) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map(item => {
        // Accessing the specific path: item.bookings['COUNT(ROWID)']
        const rawDate = item.bookings.created_date;
        const countValue = parseInt(item.bookings['COUNT(ROWID)'], 10) || 0;

        // Formatting date to be more readable on the graph (e.g., "22 Jan")
        const dateObj = new Date(rawDate);
        const formattedName = dateObj.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric' // Add this line
        });

        return {
            name: formattedName,
            tasks: countValue,
            fullDate: rawDate // kept for sorting if needed
        };
    }).sort((a, b) => new Date(a.fullDate) - new Date(b.fullDate));
};

const transformYearlyData = (rows) => {
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const yearly = months.map(m => ({ name: m, tasks: 0 }));

    rows.forEach(item => {
        const row = item.bookings;
        const date = new Date(row.created_date);
        const monthIndex = date.getMonth(); // 0–11
        yearly[monthIndex].tasks += Number(row["COUNT(ROWID)"]);
    });

    return yearly;
};


const getCurrentWeekRange = () => {
    const today = new Date();

    // Clone date to avoid mutation bugs
    const current = new Date(today);

    // JS getDay(): Sun=0, Mon=1, ... Sat=6
    const day = current.getDay();

    // Calculate Monday
    const diffToMonday = day === 0 ? -6 : 1 - day;
    const monday = new Date(current);
    monday.setDate(current.getDate() + diffToMonday);

    // Calculate Sunday
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    const format = (date) =>
        date.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });


    return {
        startDate: format(monday),
        endDate: format(sunday)
    };
};

const getCurrentMonth = () => {
    const now = new Date();
    return {
        year: now.getFullYear(),
        month: now.getMonth() + 1 // 1–12
    };
};


export {
    transformWeeklyData,
    transformMonthlyData,
    transformYearlyData,
    getCurrentWeekRange,
    getCurrentMonth,
    transformCustomRangeData
};
